import * as vp from 'vopay';

import { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { withStyles } from 'vopay';
import { useTranslation } from 'react-i18next';
import { usePartnerLogin } from '@/providers/PartnerLogin.provider';
import { DetailsCard, DetailRow } from 'UI';
import CopyButton from '@/components/UI/CopyButton/CopyButton';
import styles from './Details.module.scss';

const cn = withStyles(styles);

type DetailsProps = {
  details: vp.AccountDetailsMap;
  agreementDetails: vp.AgreementDetailsResponse;
  onClick?: () => void;
};

type FC = FunctionComponent<DetailsProps>;

const Details: FC = ({ details }: DetailsProps) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { response } = usePartnerLogin();
  const isInsideSales = response.isInsideSales || false;
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.Details' });

  const accountDetails = details[accountId];

  const formattedAddress = [
    accountDetails?.address?.addressLine1,
    accountDetails?.address?.city,
    accountDetails?.address?.province,
    accountDetails?.address?.postalCode,
    accountDetails?.address?.country,
  ]
    .filter(Boolean)
    .join(', ');

  return (
    <div className={cn('container')}>
      <div className={cn('section')}>
        <div className={cn('sectionTitle')}>{t('accountDetails')}</div>
        <DetailsCard>
          <DetailRow label={t('accountName')} value={accountDetails?.accountName} />
          <DetailRow
            label={t('accountId')}
            value={
              <span className={cn('accountId')}>
                {accountDetails?.accountId}
                <CopyButton content={accountDetails?.accountId} />
              </span>
            }
          />
        </DetailsCard>
      </div>

      <div className={cn('section')}>
        <div className={cn('sectionTitle')}>{t('businessDetails')}</div>
        <DetailsCard>
          <DetailRow label={t('legalBusinessName')} value={accountDetails?.legalBusinessName} />
          <DetailRow label={t('dbaName')} value={accountDetails?.DBAName} />
          {!isInsideSales && <DetailRow label={t('address')} value={formattedAddress} />}
        </DetailsCard>
      </div>
    </div>
  );
};

export default Details;
